export const SHOW = "kyotech/modal/SHOW";
export const DISMISS = "kyotech/modal/DISMISS";
